module.exports = __webpack_public_path__ + "media/win3.22a46ad2.mp3";